import styled from 'styled-components';

interface ScrollContainerProps {
    containerHeight?: number | 'fit-content';
}

export const ScrollContainer = styled.div<ScrollContainerProps>`
    overflow: ${({ containerHeight }) => (containerHeight === 'fit-content' ? 'hidden' : 'auto')};
    height: ${({ containerHeight }) =>
        typeof containerHeight === 'number' ? `${containerHeight}px` : containerHeight};
`;

export const VirtualizerRoot = styled.div<{ totalSize: number }>`
    height: ${({ totalSize }) => `${totalSize}px`};
    width: 100%;
    position: relative;
`;

export const VirtualizerItems = styled.div<{ translateY: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: ${({ translateY }) => `translateY(${translateY}px)`};
    box-sizing: border-box;
`;
